import { jsxs as l, jsx as a, Fragment as w } from "react/jsx-runtime";
import { R as O, b as R, P as x, O as D, C as I, T as M, a as c, D as k } from "./index-Bsd8a-_6.js";
import { R as B } from "./index-Ce7GeIbO.js";
import { c as i } from "./clsx-OuTLNxxd.js";
import { B as L } from "./button.types-DrjRFeap.js";
import "./components/elements/button/iconButton/iconButton.js";
import { Divider as j } from "./components/elements/divider/divider.js";
import { I as P } from "./icon-DtMxVF3r.js";
import "./components/elements/icon/iconsList.js";
import { StepperDots as z } from "./components/elements/stepperDots/stepperDots.js";
const E = "_modal_j9iq0_29", o = {
  "modal-overlay": "_modal-overlay_j9iq0_29",
  "dialog-overlay-show": "_dialog-overlay-show_j9iq0_1",
  modal: E,
  "dialog-content-slide-up": "_dialog-content-slide-up_j9iq0_1",
  "dialog-content-show": "_dialog-content-show_j9iq0_1",
  "is-small": "_is-small_j9iq0_67",
  "is-medium": "_is-medium_j9iq0_70",
  "is-large": "_is-large_j9iq0_73",
  "no-confirm-action": "_no-confirm-action_j9iq0_80",
  "modal-content": "_modal-content_j9iq0_80",
  "modal-bottom": "_modal-bottom_j9iq0_83",
  "modal-title": "_modal-title_j9iq0_87",
  "is-closable": "_is-closable_j9iq0_104",
  "outer-modal-content": "_outer-modal-content_j9iq0_109",
  "modal-actions": "_modal-actions_j9iq0_131",
  "no-dividers": "_no-dividers_j9iq0_148",
  "confirm-cta": "_confirm-cta_j9iq0_151",
  "no-alternative-action": "_no-alternative-action_j9iq0_154",
  "alternative-cta": "_alternative-cta_j9iq0_157",
  "alternative-cta-multi": "_alternative-cta-multi_j9iq0_160",
  "modal-close": "_modal-close_j9iq0_169"
};
function Y({
  size: q = "medium",
  title: u,
  description: d,
  onClose: m,
  children: f,
  dialogTriggerNode: v,
  alternativeAction: t,
  confirmActionText: n,
  onConfirmAction: g,
  onAlternativeAction: p,
  isOpen: C,
  onChange: _,
  areDividersVisible: s = !0,
  isClosable: h = !0,
  multiSteps: e,
  onInteractOutside: N,
  confirmationButton: b = {
    isLoading: !1,
    disabled: !1
  }
}) {
  const y = i(o.modal, o[F[q]], !n && o["no-confirm-action"]);
  return /* @__PURE__ */ l(O, { open: C, onOpenChange: (r) => {
    _ && _(r), r === !1 && m && m(r);
  }, children: [
    /* @__PURE__ */ a(R, { asChild: !0, children: v }),
    /* @__PURE__ */ l(x, { children: [
      /* @__PURE__ */ a(D, { className: o["modal-overlay"] }),
      /* @__PURE__ */ l(I, { className: y, onInteractOutside: N, children: [
        /* @__PURE__ */ l("div", { children: [
          /* @__PURE__ */ l(M, { className: i(o["modal-title"], h && o["is-closable"]), children: [
            u,
            h && /* @__PURE__ */ a(c, { asChild: !0, children: /* @__PURE__ */ a("button", { className: o["modal-close"], "aria-label": "Close", children: /* @__PURE__ */ a(P, { name: "remove", size: "large" }) }) })
          ] }),
          d && /* @__PURE__ */ a(B, { asChild: !0, children: /* @__PURE__ */ a(k, { children: d }) })
        ] }),
        s && /* @__PURE__ */ a(j, { space: "no" }),
        /* @__PURE__ */ a("div", { className: o["outer-modal-content"], children: /* @__PURE__ */ a("div", { className: o["modal-content"], children: f }) }),
        n && /* @__PURE__ */ l(w, { children: [
          s && /* @__PURE__ */ a(j, { space: "no", className: o["modal-bottom"] }),
          /* @__PURE__ */ l("div", { className: i(o["modal-actions"], !s && o["no-dividers"]), children: [
            t && /* @__PURE__ */ a(c, { asChild: !0, children: /* @__PURE__ */ a(
              "button",
              {
                className: i(
                  o["alternative-cta"],
                  (e == null ? void 0 : e.currentStep) === 0 && o["alternative-cta-multi"]
                ),
                onClick: p,
                children: t
              }
            ) }),
            e && /* @__PURE__ */ a(z, { currentStep: e.currentStep, stepsCount: e.stepNumber }),
            /* @__PURE__ */ a(c, { asChild: !0, children: /* @__PURE__ */ a(
              L,
              {
                onClick: g,
                className: i(
                  o["confirm-cta"],
                  !e && !t && o["no-alternative-action"]
                ),
                text: n,
                ...b
              }
            ) })
          ] })
        ] })
      ] })
    ] })
  ] });
}
const F = {
  small: "is-small",
  medium: "is-medium",
  large: "is-large"
};
export {
  Y as M,
  F as a
};
